/** Captura / restaura scroll en contenedores reales (modal ficha, shell consultorio, etc.). */

function isScrollable(el) {
  if (!(el instanceof HTMLElement)) return false;
  const { overflowY, overflowX } = getComputedStyle(el);
  const y = /(auto|scroll|overlay)/.test(overflowY) && el.scrollHeight > el.clientHeight + 1;
  const x = /(auto|scroll|overlay)/.test(overflowX) && el.scrollWidth > el.clientWidth + 1;
  return y || x;
}

/** Contenedores con scroll desde un nodo hacia arriba. */
export function findScrollableAncestors(fromEl) {
  const chain = [];
  const seen = new Set();
  let el = fromEl instanceof HTMLElement ? fromEl : null;

  while (el && el !== document.documentElement) {
    if (isScrollable(el) && !seen.has(el)) {
      seen.add(el);
      chain.push(el);
    }
    el = el.parentElement;
  }

  const fallbacks = [
    '.ficha-odonto-modal-body',
    '.consultorio-wrap--dash .csl-shell',
    document.scrollingElement,
    document.documentElement,
  ];

  fallbacks.forEach((node) => {
    const el = typeof node === 'string' ? document.querySelector(node) : node;
    if (el && !seen.has(el)) {
      seen.add(el);
      chain.push(el);
    }
  });

  return chain;
}

export function captureScrollPositions(fromEl) {
  const snapshots = findScrollableAncestors(fromEl).map((node) => ({
    node,
    top: node.scrollTop,
    left: node.scrollLeft,
  }));

  snapshots.push({
    node: window,
    top: window.scrollY,
    left: window.scrollX,
  });

  return snapshots;
}

export function restoreScrollPositions(snapshots) {
  if (!snapshots?.length) return;
  snapshots.forEach(({ node, top, left }) => {
    if (!node) return;
    if (node === window) {
      window.scrollTo(typeof left === 'number' ? left : window.scrollX, typeof top === 'number' ? top : window.scrollY);
      return;
    }
    if (typeof top === 'number') node.scrollTop = top;
    if (typeof left === 'number') node.scrollLeft = left;
  });
}

/** Ejecuta fn y restaura scroll tras commit + pintado. */
export function preserveScrollWhile(fromEl, fn) {
  const snapshots = captureScrollPositions(fromEl);
  fn();
  const restore = () => restoreScrollPositions(snapshots);
  restore();
  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(() => {
      restore();
      requestAnimationFrame(restore);
    });
  }
}
